<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <dropdown-container
                        :open="containers.open.users"
                        :heading="'USERS'"
                        v-on:open-container="closeContainers(); containers.open.users = true;"
                        v-on:close-container="closeContainers();">
                        <all-users></all-users>
                    </dropdown-container>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col>
                    <dropdown-container
                        :open="containers.open.clients"
                        :heading="'CLIENTS'"
                        v-on:open-container="closeContainers(); containers.open.clients = true;"
                        v-on:close-container="closeContainers();">
                        <all-clients></all-clients>
                    </dropdown-container>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col>
                    <dropdown-container
                        :open="containers.open.events"
                        :heading="'EVENTS'"
                        v-on:open-container="closeContainers(); containers.open.events = true;"
                        v-on:close-container="closeContainers();">
                        <all-events></all-events>
                    </dropdown-container>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import AllClients from "./clients/AllClients";
import AllEvents from "./events/AllEvents";
import AllUsers from "./users/AllUsers";
import DropdownContainer from "@/components/DropdownContainer";

export default {
    components: {
        AllClients,
        AllEvents,
        AllUsers,
        DropdownContainer
    },

    data() {
        return {
            containers: {
                open: {
                    users: true,
                    clients: false,
                    events: false
                }
            }
        }
    },

    methods: {
        closeContainers() {
            this.containers.open.users = false;
            this.containers.open.clients = false;
            this.containers.open.events = false;
        },
    }
}
</script>